import { Injectable }    from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http, ResponseContentType } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { ProductClass } from '../entity/product-class';
import { Package } from '../entity/package';
import { ProductPackage } from '../entity/product-package';
import { Product } from '../entity/product';
import { Order } from '../entity/order';
import { Request } from '../entity/request';
import { ThirdParty } from '../entity/third-party';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class OrderService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  getProductClasses(): Promise<any> {
    return this.http.get(environment.apiUrl+'site-api/list/product-class')
               .toPromise()
               .then(
                  function(response) {
                    let productClasses = [];
                    let response_obj = response.json();
                    for(let index in response_obj){
                      let productClass = new ProductClass();
                      productClass.fromJSON(response_obj[index]);
                      productClasses[productClasses.length] = productClass;
                    }
                    return productClasses;
                  }
                )
               .catch(this.handleError);
  }

  getProducts(productClassCode): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/list/products', JSON.stringify({productClassCode: productClassCode}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let products = [];
                    let response_obj = response.json();
                    for(let index in response_obj['products']){
                      let product = new Product();
                      product.fromJSON(response_obj['products'][index]);
                      products.push(product);
                    }
                    return products;
                  }
                )
               .catch(this.handleError);
  }

  getAnalysisByCode(code): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/order/analysis-code', JSON.stringify({code: code}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    if (response_obj['analysisCode']) {
                      let analysisCode = new ProductPackage();
                      analysisCode.fromJSON(response_obj['analysisCode']);
                      return analysisCode;
                    } else {
                      return null;
                    }
                  }
                )
               .catch(this.handleError);
  }

  getRecipientsList(thirdPartyId): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/list/recipients', JSON.stringify({thirdPartyId: thirdPartyId}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let recipients = [];
                    let response_obj = response.json();
                    for(let index in response_obj['recipients']){
                      let thirdParty = new ThirdParty();
                      thirdParty.fromJSON(response_obj['recipients'][index]);
                      recipients[recipients.length] = thirdParty;
                    }
                    return recipients;
                  }
                )
               .catch(this.handleError);
  }

  getPackages(productId): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/list/packages', JSON.stringify({productId: productId}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let packages = [];
                    let response_obj = response.json();
                    let packagesJob = {};
                    for(let index in response_obj['packages']){
                      let pack = new Package();
                      pack.fromJSON(response_obj['packages'][index]['package']);
                      pack.label = response_obj['packages'][index]['packageLabelSite']
                      pack.class =  response_obj['packages'][index]['packageClass']
                      packages[packages.length] = pack;
                      packagesJob[pack.code] = response_obj['packages'][index]['jobCode'];
                    }
                    return {
                      packages: packages,
                      jobCodes: packagesJob
                    };
                  }
                )
               .catch(this.handleError);
  }

  getOrder(orderNumber): Promise<Order> {
    return this.http.get(environment.apiUrl+'site-api/order/'+orderNumber)
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    let order = new Order();
                    let request = new Request();
                    order.fromJSON(response_obj['order']);
                    request.fromJSON(response_obj['request']);
                    order.objectRef = request;
                    return order;
                  }
                )
               .catch(this.handleError);
  }

  placeOrder(data): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/order/new', JSON.stringify(data), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    let orderCode = response_obj['orderCode'];
                    return orderCode;
                  }
                )
               .catch(this.handleError);
  }

  updateOrder(data): Promise<any> {
    return this.http.post(environment.apiUrl + 'site-api/order/update', JSON.stringify(data), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    return response.json().orderCode;
                  }
                )
               .catch(this.handleError);
  }

  getLabSirets(): Promise<any> {
    return this.http.get(environment.apiUrl + 'site-api/laboratoires/liste_lab_sirets', {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    return response.json();
                  }
                )
               .catch(this.handleError);
  }
  getWaitingClientRequestStatusCode(): Promise<any> {
    return this.http.get(environment.apiUrl + 'site-api/client_request_status/get_waiting_client_request_status_code', {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    return response.json();
                  }
                )
               .catch(this.handleError);
  }

  downloadOrderForm(orderNumber): Observable<any> {
        const options = {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        };

        const params = {
            'orderNumber': orderNumber
        };
        return this.http.post(environment.apiUrl + 'site-api/order-pdf', JSON.stringify(params), options)
            .map(
                function(response) {
                    return response.blob();
                }
            )
            .catch(this.handleError);
    }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/order/order.service.ts